import axios from 'axios'

export default {
    namespaced: true,
    state: {
        categories: []
    },
    getters: {
    },
    mutations: {
        FETCH_CATEGORIES(state, categories) {
            state.categories = categories
        },
        ADD_CATEGORIES(state, category) {
            state.categories.push(category)
        },
        EDIT_CATEGORIES(state, category) {
            const index = state.categories.findIndex(
                item => item.id === category.id
            )
            if (index !== -1) {
                Object.assign(state.categories[index], category)
            }
        },
        DEL_CATEGORIES(state, category) {
            const index = state.categories.findIndex(
                item => item.id === category.id
            )
            if (index !== -1) {
                state.categories.splice(index, 1)
            }
        }
    },
    actions: {
        fetch({commit, dispatch}, filter) {
            return new Promise((resolve, reject) => {
                axios.post(
                    '/api/mixins/categories/list', filter
                ).then(({data}) => {
                    commit('FETCH_CATEGORIES', data.data)
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                    reject(error)
                })
            })
        },
        add({commit, dispatch, rootState}, data) {
            return axios.post(
                '/api/mixins/categories/add',
                prepareData(data, rootState), {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(({data}) => {
                commit('ADD_CATEGORIES', data.data)
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        edit({commit, dispatch, rootState}, editedItem) {
            return axios.post(
                '/api/mixins/categories/edit/' + editedItem.id,
                prepareData(editedItem, rootState), {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(({data}) => {
                commit('EDIT_CATEGORIES', data.data)
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        delete({commit, dispatch}, itemId) {
            return axios.delete(
                '/api/mixins/categories/dell/' + itemId
            ).then(({data}) => {
                commit('DEL_CATEGORIES', data.data)
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        copy(dispatch, data) {
            return axios.post(
                '/api/menu-manager/categories/copy', data
            ).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        }
    }
}

function prepareData (data, rootState) {
    const fd = new FormData()
    if (data.image) {
        fd.append('image', data.image)
    }
    fd.append('hotel_id', String(rootState.auth.currentHotel.id))
    fd.append('name', data.name)

    return fd
}
